var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.influencerShop)?_c('v-row',_vm._l((_vm.influencerShop.groups),function(item,index){return _c('v-col',{key:index,attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('Cell',{attrs:{"item":item}})],1)}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }